const colors = ["orange", "red", "green", "purple", "blue", "yellow"];

export const getRandomColor = ()  =>{
    const num = Math.floor(Math.random() * (2 - 0 + 1) + 0);
    return colors[num];
}